/**
 * AreaStatusLink
 */

import React from "react";
import Icon from "components/Icon";
import Link from "components/Link";
import clsx from "clsx";
import { AreaPageLink, IImage } from "types/global";

interface Props {
    /** The url to the area page */
    url: string;

    /** Risk icon image */
    riskImage: IImage;

    /** Risk text */
    riskText: string;

    /** Area name for stated risk */
    areaName: string;

    /** Areas name for popular destination */
    areas: string;

    /** Area index for id */
    index: number;
    className?: string;
    areaPageLinksSubForecastText?: string;
    areaSubPageLinks: AreaPageLink[];
    isOpen?: boolean;
    onToggle: any;
}

const AreaStatusLink: React.FC<Props> = ({
    url,
    riskImage,
    riskText,
    areaName,
    areas,
    index,
    className,
    areaPageLinksSubForecastText,
    areaSubPageLinks,
    isOpen,
    onToggle,
}) => {
    const hasChildren = areaSubPageLinks != null && areaSubPageLinks.length > 0;

    return (
        <>
            <li
                id={areaName}
                className={clsx(
                    "area-status-li relative",
                    isOpen ? "outline-red" : ""
                )}
                aria-expanded={isOpen}
                onClick={onToggle}
            >
                <Link
                    href={hasChildren ? "#" : url}
                    className={clsx(
                        "flex justify-between items-center group",
                        className
                    )}
                >
                    <div className="flex">
                        {hasChildren ? (
                            <div className="w-16 mr-4">
                                {areaSubPageLinks?.[1]?.riskImage && (
                                    <img
                                        src={areaSubPageLinks[1].riskImage.src}
                                        alt={
                                            areaSubPageLinks[1].riskImage.alt ||
                                            ""
                                        }
                                        aria-hidden="true"
                                        className="absolute left-4 w-16 h-16"
                                    />
                                )}
                                {areaSubPageLinks?.[0]?.riskImage && (
                                    <img
                                        src={areaSubPageLinks[0].riskImage.src}
                                        alt={
                                            areaSubPageLinks[0].riskImage.alt ||
                                            ""
                                        }
                                        aria-hidden="true"
                                        className="absolute left-0 w-16 h-16"
                                    />
                                )}
                            </div>
                        ) : (
                            <img
                                src={riskImage?.src || ""}
                                alt={riskImage?.alt || ""}
                                aria-hidden="true"
                                className="w-16 h-16"
                            />
                        )}

                        <div className="flex flex-col justify-center ml-2 py-3">
                            <h3
                                id={`area-status-link-${index}`}
                                className="order-2 text-h5 font-semibold group-hover:underline"
                            >
                                {areaName}
                            </h3>
                            {!hasChildren && (
                                <p className="order-1 text-base font-bold text-orange">
                                    {riskText}
                                </p>
                            )}
                            <span className="text-sm order-3">{areas}</span>
                        </div>
                    </div>

                    <Icon
                        size={1}
                        icon={
                            !hasChildren ? "chevron" : isOpen ? "minus" : "plus"
                        }
                        direction="left"
                        className="mr-4 lg:mr-5"
                    />
                </Link>
                {hasChildren && isOpen && (
                    <ul>
                        <li>
                            <p
                                className={clsx(
                                    "ml-4 text-grey-darker",
                                    className
                                )}
                            >
                                {areaPageLinksSubForecastText}
                            </p>
                        </li>
                        {areaSubPageLinks!.map((sub, index) => (
                            <li
                                key={sub.url || index}
                                id={sub.areaName}
                                className="area-status-li border-b-2 last:border-t-2 border-grey-light mb-0"
                            >
                                <Link
                                    href={sub.url}
                                    className={clsx(
                                        "flex justify-between items-center group",
                                        className
                                    )}
                                >
                                    <div className="flex">
                                        {sub.riskImage?.src && (
                                            <img
                                                src={sub.riskImage.src}
                                                alt={sub.riskImage.alt || ""}
                                                aria-hidden="true"
                                                className="w-16 h-16"
                                            />
                                        )}

                                        <div className="flex flex-col justify-center ml-2 py-3">
                                            <h3
                                                id={`area-status-link-${
                                                    index + 10
                                                }`}
                                                className="order-2 text-h5 font-semibold group-hover:underline"
                                            >
                                                {sub.areaName}
                                            </h3>
                                            {sub.riskText && (
                                                <p className="order-1 text-base font-bold text-orange">
                                                    {sub.riskText}
                                                </p>
                                            )}
                                             <span className="text-sm order-3">{sub.areas}</span>
                                        </div>
                                    </div>

                                    <Icon
                                        size={1}
                                        icon="chevron"
                                        direction="left"
                                        className="mr-4 lg:mr-5"
                                    />
                                </Link>
                            </li>
                        ))}
                    </ul>
                )}
            </li>            
        </>
    );
};

export default AreaStatusLink;
